import { cookieStore } from "@/shared/utils/store/use-store";

export class FixedHelp {
    public static init() {
        $(document).ready(() => {
            const elem = $("#fixed-help");
            if (!elem.length) return;

            const cookieName = "hideFixedHelp";

            if (cookieStore.get(cookieName) === "true") {
                elem.removeClass("active");
            } else {
                if (!elem.hasClass("active")) {
                    elem.addClass("active");
                }
            }

            $("#switch-help").click(() => {
                elem.toggleClass("active");
                cookieStore.set(cookieName, `${!elem.hasClass("active")}`);
            });
        });
    }
}
